module.exports = __webpack_public_path__ + "static/media/sales-up.57712262.jpg";